export default __webpack_public_path__ + "static/icon-instagram-c8b2069100637247650bf384b7fcbed1.svg";